import { render, staticRenderFns } from "./indexDirecciones.vue?vue&type=template&id=4513d682&"
import script from "./indexDirecciones.vue?vue&type=script&lang=ts&"
export * from "./indexDirecciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports